import cx from "classnames";
import dynamic from "next/dynamic";
import React from "react";

const HowItWorks = dynamic(() => import("../commons/how-it-works"), { ssr: true });

const StoreLinksHowItWorks = () => {
  return (
    <HowItWorks
      headerTextSeries={[
        ["How", "to", "use"],
        ["store", "links"],
      ]}
      steps={steps}
    />
  );
};

const steps = [
  {
    description: "Create an store and add your products - then you get a link",
    image:
      "https://res.cloudinary.com/catlog/image/upload/v1670791956/front-pages/mockups/store-link-setup-complete.webp",
  },
  {
    description: "Add your link to your social profiles and share to customers when they reach out",
    image:
      "https://res.cloudinary.com/catlog/image/upload/v1670792011/front-pages/mockups/customer-initiates-conversation.webp",
  },
  {
    description: "Customers visit your link and select items they want to buy",
    image:
      "https://res.cloudinary.com/catlog/image/upload/v1670791986/front-pages/mockups/selection-made-on-store.webp",
  },
  {
    description: "The order is sent to your whatsapp so you can chat with the customer and close your sales",
    image: "https://res.cloudinary.com/catlog/image/upload/v1670792029/front-pages/mockups/customer-sends-order.webp",
  },
];

export default StoreLinksHowItWorks;
